import React, {useContext, useState} from 'react';
import {Button, Grid, Hidden, InputAdornment, Paper, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {DispatchContext} from '../../../store';
import {SNACKBAR_OPEN} from '../../../reducers';
import {authServices} from '../../../services/AuthServices';
import {usersProfileAPi} from '../../../services/UserServices';
import * as Yup from 'yup';
import Card from '@mui/material/Card';
import {Images} from '../../../common/Assets/Images';
import IconButton from '@mui/material/IconButton';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import ForgotPassword from './ForgotPassword';

export const loginValidateSchema = Yup.object().shape({
  username: Yup.string().required('Field is required').nullable(),
  password: Yup.string().required('Field is required').nullable(),
});

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = useState(false);

  const handleSubmit = async (values, {setSubmitting}) => {
    await authServices('post', '/token/', {...values}, dispatch)
      .then((res) => {
        if (res?.data?.access) {
          return usersProfileAPi('get').then((response) => {
            const currentRole = response?.data?.current_role;
            localStorage.setItem('role', JSON.stringify(currentRole));
            localStorage.setItem('user', JSON.stringify(response?.data));
            dispatch({type: 'ROLE', payload: {...currentRole}});
            dispatch({
              type: SNACKBAR_OPEN,
              payload: {
                isNotify: true,
                severity: 'success',
                message: 'Login successful',
              },
            });
            if (currentRole?.name === 'super_admin' || currentRole?.name === 'museum_chief') {
              navigate('/management/museums');
            } else if (currentRole?.name === 'curator') {
              navigate('/management/user-management');
            } else if (currentRole?.name === 'assistant') {
              navigate('/management/acquisition');
            } else if (currentRole?.name === 'interns' || currentRole?.name === 'volunteers') {
              navigate('/management/catalogue-artefacts');
            } else if (currentRole?.name === 'conservator') {
              navigate('/management/conservator');
            } else if (currentRole?.name === 'receptionist') {
              navigate('/management/fd-dashboard');
            } else {
              navigate('/');
            }
          });
        }
      }).catch((error) => {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {
            isNotify: true,
            severity: 'error',
            message: error?.message || 'Login failed',
          },
        });
      }).finally(() => {
        setSubmitting(false);
      });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClosePwd = () => {
    setShow(false);
  }

  const handleOpenPwd = () => {
    handleClosePwd();
    setShow(true);
  };

  return (
    <React.Fragment>
      <Hidden smDown={true}>
        <div style={{height: '100vh', position: 'relative', backgroundColor: '#f0f0f0'}}>
          <div>
            <div style={{width: '69.7%', height: '100%', backgroundColor: '#fff', position: 'absolute', right: 0}}/>
            <div style={{width: '30.3%', height: '100%', backgroundColor: '#CEDEFF', position: 'absolute', left: 0}}/>
          </div>
          <div style={{position: 'absolute', top: '50%', left: '30%', transform: 'translate(-50%, -50%)', zIndex: 1}}>
            <Grid container spacing={2}>
              <Grid item sm={3} xs={3}/>
              <Grid item sm={6} xs={6}>
                <Card className={'box-shadow-3DD'} sx={{width: '80vw', height: '85vh'}}>
                  <Grid container sx={{height: '100%', alignItems: 'center'}}>
                    <Grid item sm={3} sx={{backgroundColor: '#CEDEFF', height: '100%', alignItems: 'center'}}>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '80%'
                      }}
                           className={'hand-cursor'}
                           onClick={() => navigate('/')}
                      >
                        <img src={Images.logoWhite} alt=""
                             style={{width: 100, height: 100, objectFit: 'contain'}}/>
                        <p>
                          <i>
                            Museums of Bhutan
                          </i>
                        </p>
                        <p></p>
                      </div>
                    </Grid>
                    <Grid item sm={9}>
                      <Formik initialValues={{username: '', password: ''}} validationSchema={loginValidateSchema}
                              onSubmit={handleSubmit}>
                        {({
                            values,
                            errors,
                            isSubmitting,
                            handleChange,
                            handleBlur,
                            ...formik
                          }) => (
                          <Form>
                            <Stack padding={{lg: 2, md: 2, sm: 2, xs: 3}} marginTop={{lg: 10, md: 30, sm: 30, xs: 20}}>
                              <Grid container flexDirection={'row'}
                                    display={'flex'} alignItems={'center'}
                                    justifyContent={'center'}>
                                <Grid item lg={8} md={6} sm={6} xs={12} align={'center'}>
                                  <Paper elevation={0} sx={{width: {lg: '65%', md: '65%', sm: '76%', xs: '100%'}}}>
                                    <div align={'left'}>
                                      <Typography variant={'h5'} component={'h1'} fontWeight={700}>Welcome
                                        Back</Typography>
                                      <Typography variant={'body2'} component={'h1'} color={'#7E7D7D'}>
                                        Please enter your details to log in</Typography>
                                    </div>
                                    <Stack paddingTop={4}>
                                      <Typography variant={'body2'} component={'h1'} fontWeight={700}
                                                  align={'left'}>Username</Typography>
                                      <Field component={TextField} label={'Enter your username'} name={'username'}
                                             margin={'dense'}
                                             InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}}/>
                                      <Typography variant={'body2'} component={'h1'} marginTop={2} fontWeight={700}
                                                  align={'left'}>Password</Typography>
                                      <Field component={TextField} label={'Password'} name={'password'} margin={'dense'}
                                             type={!showPassword ? 'password' : 'text'}
                                             InputProps={{
                                               endAdornment: (
                                                 <InputAdornment position="end">
                                                   <IconButton
                                                     aria-label="toggle password visibility"
                                                     onClick={handleClickShowPassword}
                                                     edge="end"
                                                   >
                                                     {showPassword ? <Visibility sx={{fontSize: 20}}/> :
                                                       <VisibilityOff sx={{fontSize: 20}}/>}
                                                   </IconButton>
                                                 </InputAdornment>
                                               ),
                                             }}
                                             InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}}/>
                                      <Stack flexDirection={'row'} alignItems={'center'}
                                             justifyContent={'space-between'}>
                                        <Typography variant={'subtitle2'} component={'p'} color={'#1A1818'}
                                                    className={'hand-cursor'}
                                                    fontWeight={700} fontSize={13.3} onClick={handleOpenPwd}>Forgot
                                          Password?</Typography>
                                      </Stack>
                                      <Button variant={'contained'} className={'text-bold text-capitalize box-shadow'}
                                              type={'submit'} disabled={isSubmitting}
                                              sx={{
                                                ':hover': {bgcolor: '#bfd2fa'},
                                                bgcolor: '#a6bff5',
                                                color: '#3e3d3d',
                                                mt: 2
                                              }} fullWidth
                                              disableElevation>Sign In</Button>
                                    </Stack>
                                  </Paper>
                                </Grid>
                              </Grid>
                            </Stack>
                          </Form>
                        )}
                      </Formik>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        </div>
      </Hidden>
      <Hidden smUp={true}>
        <Formik initialValues={{username: '', password: ''}} validationSchema={loginValidateSchema}
                onSubmit={handleSubmit}>
          {({
              values,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              ...formik
            }) => (
            <Form>
              <Stack padding={{lg: 2, md: 2, sm: 2, xs: 3}} marginTop={{lg: 10, md: 30, sm: 30, xs: 20}}>
                <Grid container flexDirection={'row'}
                      display={'flex'} alignItems={'center'}
                      justifyContent={'center'}>

                  <Grid item lg={5} md={6} sm={6} xs={12} align={'center'}>
                    <Paper elevation={0} sx={{width: {lg: '65%', md: '65%', sm: '76%', xs: '100%'}}}>
                      <div align={'left'}>
                        <Typography variant={'h5'} component={'h1'} fontWeight={700}>Welcome Back</Typography>
                        <Typography variant={'body2'} component={'h1'} color={'#7E7D7D'}>
                          Please enter your details to log in</Typography>
                      </div>
                      <Stack paddingTop={4}>
                        <Typography variant={'body2'} component={'h1'} fontWeight={700}
                                    align={'left'}>Username</Typography>
                        <Field component={TextField} label={'Enter your username'} name={'username'} margin={'dense'}
                               InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}}/>
                        <Typography variant={'body2'} component={'h1'} marginTop={2} fontWeight={700}
                                    align={'left'}>Password</Typography>
                        <Field component={TextField} label={'Password'} name={'password'} margin={'dense'}
                               type={'password'}
                               InputLabelProps={{style: {fontSize: 13, color: '#7E7D7D'}}}/>
                        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
                          <Typography variant={'subtitle2'} component={'p'} color={'#1A1818'} className={'hand-cursor'}
                                      fontWeight={700} fontSize={13.3} onClick={handleOpenPwd}>Forgot
                            Password?</Typography>
                        </Stack>
                        <Button variant={'contained'} className={'text-bold text-capitalize'} type={'submit'}
                                disabled={isSubmitting}
                                sx={{':hover': {bgcolor: '#1A1818'}, bgcolor: '#1A1818', color: '#fff', mt: 2}}
                                fullWidth
                                disableElevation>Sign In</Button>
                      </Stack>
                    </Paper>
                  </Grid>
                </Grid>
              </Stack>
            </Form>
          )}
        </Formik>
      </Hidden>
      <ForgotPassword open={show} handleClose={handleClosePwd}/>
    </React.Fragment>
  );
}
